export enum EmailProvider {
    SendGrid = 0,
    AmazonSES = 1,
}

export enum SendGridStatus {
    Bounce = 'bounce',
    Dropped = 'dropped',
    Blocked = 'blocked',
    Deferred = 'deferred',
    Processed = 'processed',
    Delivered = 'delivered',
    Empty = '',
}

export enum AwsSESStatus {
    Delivery = 'Delivery',
    Bounce = 'Bounce',
    Send = 'Send',
    Reject = 'Reject',
    DeliveryDelay = 'DeliveryDelay',
    Complaint = 'Complaint',
    Empty = '',
}
